import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SplitButton } from './split-button.model';
import { IconComponent } from '../icon/icon.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'sc-split-button',
  styleUrls: ['./split-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <button
      *ngFor="
        let splitButton of splitButtons;
        index as i;
        first as isFirst;
        last as isLast
      "
      type="button"
      [class.is-first]="isFirst"
      [class.is-last]="isLast"
      [class.is-active]="activeButtonIndex === i"
      (click)="splitButton.action()"
    >
      {{ splitButton.label ? splitButton.label : '' }}
      <sc-icon *ngIf="splitButton.icon" [name]="splitButton.icon"></sc-icon>
    </button>
  `,
  imports: [NgFor, NgIf, IconComponent],
})
export class SplitButtonComponent {
  @Input() splitButtons: SplitButton[];
  @Input() activeButtonIndex = -1;
}
